'use client';

import React, { useState } from 'react';
import { SlideshowLightbox } from 'lightbox.js-react';
import Image from 'next/image';
import './newFencyBox.scss';
import { imageData } from '@/config/defaultBlur';
import { MdWorkspacePremium } from 'react-icons/md';

export interface Image {
  largeURL: string;
  thumbnailURL: string;
  caption: string;
  thumbnailBlurURL: string;
  premium: string;
}

const NewFancyBox = ({ images }: { images: Image[] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const handleImageClick = (index: number) => {
    setCurrentImageIndex(index);
    setIsOpen(true);
  };
  const lightboxImages = images.map((img) => ({
    src: img.largeURL,
    alt: img.caption,
    caption: img.caption,
  }));

  return (
    <div>
      <div className="row">
        {images.map((image, index) => (
          <div
            key={index}
            role="button"
            tabIndex={0}
            className="themeCard col-md-3 col-sm-6 col-12"
            onClick={() => handleImageClick(index)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleImageClick(index);
              }
            }}
            aria-label={`View image: ${image.caption}`}
            aria-describedby={`image-${index}`}
          >
            <div
              style={{
                flex: 1,
                position: 'relative',
                width: '100%',
                height: 150,
                border: '1px solid #ccc',
                borderRadius: '5px',
              }}
            >
              {image?.premium === 'Premium' && (
                <span className="theme-badge" title="Premium theme">
                  <MdWorkspacePremium />
                </span>
              )}
              <Image
                src={image.largeURL || '/n_images/default-blog.jpg'}
                alt={image.caption}
                fill
                quality={100}
                data-lightboxjs="unique-lightbox"
                aria-describedby={`image-${index}`}
                sizes="(max-width: 767px) 100vw, (max-width: 1200px) 50vw, 30vw"
                placeholder="blur"
                blurDataURL={image.thumbnailBlurURL || imageData.blurImage}
              />
            </div>
            <h4 aria-live="polite">{image.caption}</h4>
          </div>
        ))}
      </div>

      <SlideshowLightbox
        lightboxImgClass={'lightboxImg'}
        className="slideShowStyle"
        captionStyle={{
          fontSize: '22px',
          fontWeight: '700',
          color: '#222',
          backgroundColor: '#fefde6e6',
        }}
        framework={'next'}
        images={lightboxImages}
        theme="lightbox"
        startingSlideIndex={currentImageIndex}
        showThumbnails={false}
        showControls={false}
        iconColor="#f68b1c"
        backgroundColor="#fefde6e6"
        thumbnailBorder="transparent"
        imgAnimation="fade"
        open={isOpen}
        nextArrow={<span className="next-arrow" aria-label="Next image"></span>}
        prevArrow={
          <span className="prev-arrow" aria-label="Previous image"></span>
        }
        onClose={() => setIsOpen(false)}
        aria-labelledby="image-caption"
        aria-describedby="lightbox-description"
      />
    </div>
  );
};

export default NewFancyBox;
